<template>
  <div class="card edit-card">
    <div class="card-body">
      <div class="edit-grid">
        <div class="edit-section">
          <h6 class="section-title"><i class="fas fa-user mr-2"></i>基本情報</h6>
          <div class="field-group">
            <label>名前 <span class="required">*</span></label>
            <input type="text" class="form-control" v-model="formData.name">
          </div>
          <div class="field-group">
            <label>メールアドレス <span class="required">*</span></label>
            <input type="text" class="form-control" v-model="formData.email">
          </div>
          <div class="field-group">
            <label>パスワード <span class="required">*</span></label>
            <input type="text" class="form-control" v-model="formData.password">
          </div>
          <div class="field-group">
            <label>所属店舗</label>
            <div class="shop-checkbox-list">
              <label class="shop-checkbox-item" v-for="shop in shops" :key="shop.id">
                <input type="checkbox" :value="shop.id" v-model="selectedShopIds">
                <span class="shop-checkbox-name">{{ shop.shop_name }}</span>
              </label>
            </div>
          </div>
          <div class="field-row">
            <div class="field-group">
              <label>年齢</label>
              <input type="number" class="form-control" v-model="formData.age">
            </div>
            <div class="field-group">
              <label>性別</label>
              <select class="form-control" v-model="formData.gender">
                <option value="">選択してください</option>
                <option value="男">男</option>
                <option value="女">女</option>
                <option value="特定しない">特定しない</option>
              </select>
            </div>
          </div>
          <div class="field-row">
            <div class="field-group">
              <label>電話番号</label>
              <input type="text" class="form-control" v-model="formData.phone_number" placeholder="ハイフンなし" @keypress="validateNumber">
            </div>
            <div class="field-group">
              <label>郵便番号</label>
              <input type="text" class="form-control" v-model="formData.postal_code" placeholder="ハイフンなし" @keypress="validateNumber">
            </div>
          </div>
          <div class="field-group">
            <label>住所</label>
            <textarea class="form-control" rows="3" v-model="formData.address"></textarea>
          </div>
          <div class="field-group">
            <label>入社日</label>
            <input type="date" class="form-control" v-model="formData.date_of_joining">
          </div>
          <div class="field-group">
            <label>退職日</label>
            <input type="date" class="form-control" v-model="formData.date_of_leaving">
          </div>
        </div>

        <div class="edit-section">
          <h6 class="section-title"><i class="fas fa-briefcase mr-2"></i>勤務情報</h6>
          <div class="field-group">
            <label>勤務時間 <span class="required">*</span></label>
            <div class="time-range">
              <input type="time" v-model="formData.regular_working_hours_start" class="form-control" />
              <span class="range-sep">〜</span>
              <input type="time" v-model="formData.regular_working_hours_stop" class="form-control" />
            </div>
          </div>
          <div class="field-row">
            <div class="field-group">
              <label>休憩 <span class="required">*</span></label>
              <div class="input-with-unit">
                <input type="number" v-model="formData.break_time" class="form-control" />
                <span class="unit">分</span>
              </div>
            </div>
            <div class="field-group">
              <label>時給</label>
              <div class="input-with-unit">
                <span class="unit-prefix">¥</span>
                <input type="number" class="form-control" v-model="formData.hourly_wage">
              </div>
            </div>
          </div>
          <div class="field-group">
            <label>日当交通費</label>
            <div class="input-with-unit">
              <span class="unit-prefix">¥</span>
              <input type="number" class="form-control" v-model="formData.daily_transportation_allowance">
              <span class="unit">/日</span>
            </div>
          </div>
          <div class="field-group">
            <label style="display:flex;align-items:center;gap:8px;">
              <input type="checkbox" v-model="formData.use_paid_leave" :true-value="1" :false-value="0" style="width:16px;height:16px;cursor:pointer;">
              有給を利用する
            </label>
            <div v-if="formData.use_paid_leave != 1" style="margin-top:4px;font-size:11px;color:#a0aec0;">
              ※ OFFの場合、アプリ側で有給申請の機能が表示されません
            </div>
          </div>
          <div class="field-group" v-if="formData.use_paid_leave == 1">
            <label style="display:flex;align-items:center;gap:8px;">
              <input type="checkbox" v-model="formData.paid_leave" :true-value="1" :false-value="0" style="width:16px;height:16px;cursor:pointer;">
              有給残日数を管理する
            </label>
            <div class="input-with-unit">
              <input type="number" step="0.5" class="form-control" v-model="formData.remaining_paid_leave_days"
                     :disabled="formData.paid_leave != 1"
                     :style="{ backgroundColor: formData.paid_leave != 1 ? '#f0f0f0' : '#fff' }">
              <span class="unit">日</span>
            </div>
            <div v-if="formData.paid_leave != 1" style="margin-top:4px;font-size:11px;color:#a0aec0;">
              ※ 残日数管理OFFのため、有給申請しても残日数は減りません
            </div>
          </div>
          <!-- Holiday type -->
          <div class="field-group">
            <label>休日タイプ</label>
            <div class="holiday-type-selector">
              <button type="button" :class="['holiday-btn', { active: formData.holiday_type === 1 }]" @click="formData.holiday_type = 1">
                <i class="fas fa-calendar-check mr-1"></i>土日祝
              </button>
              <button type="button" :class="['holiday-btn', { active: formData.holiday_type === 2 }]" @click="formData.holiday_type = 2">
                <i class="fas fa-sync-alt mr-1"></i>シフト制
              </button>
            </div>
          </div>
          <div class="field-group" v-if="formData.holiday_type === 2">
            <label>月あたりの休日数</label>
            <div class="input-with-unit">
              <input type="number" class="form-control" v-model="formData.monthly_days_off" min="0" max="31" style="width:80px;">
              <span class="unit">日 / 月</span>
            </div>
          </div>

          <div class="toggle-group">
            <div class="toggle-item">
              <label class="toggle-label" for="time_adjustment">タイムカード調整を行う</label>
              <label class="switch">
                <input type="checkbox" id="time_adjustment" v-model="formData.time_adjustment">
                <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Work Patterns -->
      <div class="patterns-edit-section">
        <div class="patterns-header">
          <h6 class="section-title mb-0"><i class="fas fa-clock mr-2"></i>勤務パターン</h6>
          <button class="btn btn-sm btn-success" @click="addPattern"><i class="fas fa-plus mr-1"></i>追加</button>
        </div>

        <div v-if="workPatterns.length === 0" class="text-muted text-center py-3">
          勤務パターンが登録されていません
        </div>

        <div v-for="(p, idx) in workPatterns" :key="idx" class="pattern-edit-card">
          <div class="pattern-edit-top">
            <div class="field-group mb-0" style="flex:1;">
              <label>パターン名</label>
              <input type="text" class="form-control form-control-sm" v-model="p.pattern_name" placeholder="例: 通常, 早番, 遅番">
            </div>
            <button class="btn btn-sm btn-outline-danger pattern-delete-btn" @click="removePattern(idx)" title="削除">
              <i class="fas fa-trash"></i>
            </button>
          </div>
          <div class="field-row mt-2">
            <div class="field-group mb-0">
              <label>開始</label>
              <input type="time" class="form-control form-control-sm" v-model="p.start_time">
            </div>
            <div class="field-group mb-0">
              <label>終了</label>
              <input type="time" class="form-control form-control-sm" v-model="p.end_time">
            </div>
            <div class="field-group mb-0">
              <label>休憩</label>
              <div class="input-with-unit">
                <input type="number" class="form-control form-control-sm" v-model="p.break_time" style="width:60px;">
                <span class="unit">分</span>
              </div>
            </div>
          </div>
          <div class="pattern-days-edit mt-2">
            <label class="day-check" v-for="d in dayDefs" :key="d.key">
              <input type="checkbox" v-model="p[d.key]">
              <span :class="['day-label', d.cls]">{{ d.label }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer edit-footer">
      <button class="btn btn-outline-secondary" @click="this.$router.push({name:'CompanyStaffPage'});">キャンセル</button>
      <button class="btn btn-success" @click="dialog"><i class="fas fa-save mr-1"></i>登録</button>
    </div>
  </div>

  <div class="modal fade" id="modal-default">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center py-4">
          <p class="mb-1"><strong>{{ formData.name }}</strong>を登録します。</p>
          <p class="text-muted mb-0">よろしいですか？</p>
        </div>
        <div class="modal-footer justify-content-center">
          <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">キャンセル</button>
          <button type="button" class="btn btn-success" @click="register">登録する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '../../utils/bsModal'
export default {
  data() {
    return {
      formData: {
        name: null,
        email: null,
        password: null,
        shop: [],
        regular_working_hours_start: null,
        regular_working_hours_stop: null,
        break_time: null,
        hourly_wage: null,
        remaining_paid_leave_days: null,
        age: null,
        gender: '',
        phone_number: null,
        postal_code: null,
        address: null,
        date_of_joining: null,
        date_of_leaving: null,
        daily_transportation_allowance: null,
        time_adjustment: false,
        paid_leave: false,
        use_paid_leave: 0,
        holiday_type: 1,
        monthly_days_off: 8,
      },
      shops: [],
      selectedShopIds: [],
      workPatterns: [{
        id: null,
        pattern_name: '通常',
        start_time: '09:00',
        end_time: '18:00',
        break_time: 60,
        monday: true, tuesday: true, wednesday: true, thursday: true, friday: true,
        saturday: false, sunday: false,
      }],
      dayDefs: [
        { key: 'monday', label: '月', cls: '' },
        { key: 'tuesday', label: '火', cls: '' },
        { key: 'wednesday', label: '水', cls: '' },
        { key: 'thursday', label: '木', cls: '' },
        { key: 'friday', label: '金', cls: '' },
        { key: 'saturday', label: '土', cls: 'sat' },
        { key: 'sunday', label: '日', cls: 'sun' },
      ],
    }
  },
  watch: {
    selectedShopIds(newIds) {
      // 選択された店舗のいずれかで time_adjustment が有効ならデフォルトON
      const anyEnabled = this.shops.some(s => newIds.includes(s.id) && Number(s.time_adjustment) > 0);
      if (anyEnabled) {
        this.formData.time_adjustment = true;
      }
    },
  },
  methods: {
    validateNumber(event) {
      const key = event.key;
      if (!/[0-9]/.test(key)) {
          event.preventDefault();
      }
    },
    addPattern() {
      this.workPatterns.push({
        id: null,
        pattern_name: '',
        start_time: this.formData.regular_working_hours_start || '09:00',
        end_time: this.formData.regular_working_hours_stop || '18:00',
        break_time: this.formData.break_time || 60,
        monday: true, tuesday: true, wednesday: true, thursday: true, friday: true,
        saturday: false, sunday: false,
      });
    },
    removePattern(idx) {
      this.workPatterns.splice(idx, 1);
    },
    saveWorkPatterns(staffId) {
      if (this.workPatterns.length === 0) return Promise.resolve();
      return this.$http.post(
        process.env.VUE_APP_API_PATH + '/company/staff/' + staffId + '/work-patterns/bulk',
        { patterns: this.workPatterns }
      );
    },
    dialog() {
      showModal('modal-default');
    },
    dialogClose() {
      hideModal('modal-default');
    },
    register () {
      // パスワードは6文字以上のみのバリデーション
      const pw = this.formData.password || '';
      if (pw.length < 6) {
        this.$toast.error('パスワードは6文字以上で入力してください');
        this.dialogClose();
        return;
      }

      this.formData.shop = this.selectedShopIds;
      this.formData.company_id = this.$store.getters.company;

      // Send empty string gender as null
      const submitData = { ...this.formData };
      if (!submitData.gender) submitData.gender = null;

      this.$http.post(process.env.VUE_APP_API_PATH + '/company/staff', submitData)
      .then(response => {
        if (response.data.success) {
          const newStaffId = response.data.data.id;
          // Save work patterns for the new staff
          this.saveWorkPatterns(newStaffId).then(() => {
            this.$toast.success(response.data.message);
            setTimeout(() => {
              this.$router.push({ name: 'CompanyStaffPage' });
            }, 1000);
          });
        }
      })
      .catch(error => {
        if (error.response) {
          const response = error.response.data;
          if (error.response.status === 422) {
            if (response.errors?.email) {
              this.$toast.error(response.errors.email[0]);
              return;
            }
            this.$toast.error('未入力の必須項目があります');
          } else {
            this.$toast.error(response?.message || 'エラーが発生しました');
          }
        }
      });
      this.dialogClose();
    },
    getShopList () {
      const company_id = this.$store.getters.company;
      this.$http.get(process.env.VUE_APP_API_PATH + '/company/shopList/'+company_id)
      .then(response => {
        if (response.data.success) {
          this.shops = response.data.data;
        }
      })
      .catch(error => {
        if (error.response) {
          this.$toast.error(error.response.data.message);
        }
      });
    },
  },
  mounted() {
    this.getShopList();
  },
};
</script>

<style scoped>
.edit-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

@media (max-width: 768px) {
  .edit-grid {
    grid-template-columns: 1fr;
  }
}

.section-title {
  font-size: 14px;
  font-weight: 700;
  color: #049C4C;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding-bottom: 10px;
  margin-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
}

.field-group {
  margin-bottom: 16px;
}

.field-group label {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 4px;
  display: block;
}

.required {
  color: #e53e3e;
  font-weight: 700;
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.time-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-sep {
  color: #718096;
  font-weight: 600;
}

.input-with-unit {
  display: flex;
  align-items: center;
  gap: 6px;
}

.unit {
  font-size: 14px;
  color: #718096;
  font-weight: 500;
  white-space: nowrap;
}

.unit-prefix {
  font-size: 16px;
  color: #718096;
  font-weight: 600;
}

/* Shop checkbox list */
.shop-checkbox-list {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  max-height: 180px;
  overflow-y: auto;
  padding: 8px;
}

.shop-checkbox-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin: 0;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.shop-checkbox-item:hover {
  background: #f0fff4;
}

.shop-checkbox-item input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #049C4C;
  cursor: pointer;
  flex-shrink: 0;
}

.shop-checkbox-name {
  font-size: 14px;
  color: #2d3748;
  font-weight: 500;
}

/* Toggle switch */
.toggle-group {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.toggle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f7fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.toggle-label {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #cbd5e0;
  transition: 0.2s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: #fff;
  transition: 0.2s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #049C4C;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

/* Holiday type selector */
.holiday-type-selector {
  display: flex;
  gap: 8px;
}

.holiday-btn {
  flex: 1;
  padding: 10px 16px;
  border: 1.5px solid #d2d6dc;
  border-radius: 8px;
  background: #fff;
  color: #4a5568;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: center;
}

.holiday-btn:hover {
  border-color: #049C4C;
  color: #049C4C;
}

.holiday-btn.active {
  background: #049C4C;
  border-color: #049C4C;
  color: #fff;
}

/* Work Patterns edit */
.patterns-edit-section {
  margin-top: 32px;
}

.patterns-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.pattern-edit-card {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: #f7fafc;
}

.pattern-edit-top {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}

.pattern-delete-btn {
  height: 31px;
  flex-shrink: 0;
}

.pattern-days-edit {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.day-check {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  margin: 0;
}

.day-check input[type="checkbox"] {
  display: none;
}

.day-label {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  background: #e2e8f0;
  color: #a0aec0;
  transition: all 0.15s ease;
  cursor: pointer;
}

.day-check input:checked + .day-label {
  background: #049C4C;
  color: #fff;
}

.day-check input:checked + .day-label.sat {
  background: #3182ce;
}

.day-check input:checked + .day-label.sun {
  background: #e53e3e;
}

.edit-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  background: #f7fafc;
  border-top: 1px solid #e2e8f0;
}
</style>
